import {AbstractList} from "./abstract-list";

export class SubTaskList extends AbstractList {
  constructor(item: HTMLElement) {
    super(item);
  }
}
